
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.155 41.43c7.64 0 13.834-6.193 13.834-13.834 0-7.64-6.194-13.834-13.834-13.834S7.32 19.956 7.32 27.596 13.515 41.43 21.155 41.43z","stroke":"#fff","stroke-width":"2.4","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M39.087 14.278a13.835 13.835 0 113.754 27.152","stroke":"#3DAFB8","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2 51.38a23.416 23.416 0 0138.31-.002","stroke":"#fff","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M42.845 41.43A23.383 23.383 0 0162 51.378","stroke":"#3DAFB8","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    